// extracted by mini-css-extract-plugin
export default {"image":"AdvantagesMobile_image__mUS7t","icon":"AdvantagesMobile_icon__JYqo3","title":"AdvantagesMobile_title__iz+io","text":"AdvantagesMobile_text__nCwMV"};